import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MatIconRegistry} from '@angular/material/icon';
import {LoadingService} from './core/services/loading.service';
import {delay} from 'rxjs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

/**
 * The root: only what every page needs, whatever its layout. The app bar and footer belong to
 * `AppLayoutComponent`, which routes opt into in `app.routes.ts`.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressSpinnerModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  loadingService = inject(LoadingService);
  loading = false;

  constructor(private matIconRegistry: MatIconRegistry) {
    this.matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
  }

  ngOnInit(): void {
    this.loadingService.loadingSub.pipe(delay(0)).subscribe((loading) => {
      this.loading = loading;
    });
  }
}
